<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Awb Split</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close('Cross click')"></button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <form [formGroup]="awbSplitForm">
                <div class="row">
                    <div class="col-md-4">
                        <div class="mb-2">
                            <label for="industryType" class="form-label">Industry <span
                                    class="mandatory">*</span></label>
                            <ng-select id="industryType" placeholder="Select" formControlName="ddlIndustryType"
                                [items]="industryTypeList"
                                class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                bindLabel="name" [bindValue]="'id'"
                                [ngClass]="{'is-invalid': (isFormSubmitted || awbSplitForm.get('ddlIndustryType')?.touched) && awbSplitForm.get('ddlIndustryType').errors}">
                            </ng-select>

                            <div *ngIf="(isFormSubmitted || awbSplitForm.get('ddlIndustryType')?.touched) && awbSplitForm.get('ddlIndustryType').errors"
                                class="invalid-feedback">
                                <span *ngIf="awbSplitForm.get('ddlIndustryType').errors.required">Industry
                                    Type is required</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <label class="form-label"></label>
                        <div class="mb-2">
                            <button class="btn btn-primary btn-sm" (click)="generate()"><i
                                    class='mdi mdi-refresh  me-1'></i>Generate</button>
                        </div>
                    </div>

                </div>
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 grid-container mb-2 ">
            <ag-grid-angular #agGrid style="width: 100%; height: 100%;" id="myGrid" class="ag-theme-balham"
                [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                [pagination]="true" (gridReady)="onGridReady($event)">
            </ag-grid-angular>
        </div>
    </div>
</div>

<div class="modal-footer d-flex justify-content-between align-items-center">
    <label class="form-label custom-info-label m-0">
        <i class="mdi mdi-alert-circle-outline me-1"></i>
        Note: Click on Generate to Split the records and then Save it.
    </label>
    <button type="submit" class="btn btn-outline-dark" (click)="onSaveClick()" [disabled]="!isSplitGenerated">Save</button>
</div>
